<template>
  <div class="login-container">
    <div class="login-card">
      <el-form :model="loginForm" :rules="loginFormRule" ref="loginForm" :status-icon="true">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-mobile-phone" placeholder="请输入用户名" ref="username" :maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-view" placeholder="请输入密码" type="password" :maxlength="40"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" round @click="login">登 录</el-button>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { web } from '../config'

export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRule: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.loginForm.username = localStorage.getItem('username') || ''
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.username.focus()
    })
  },
  methods: {
    login () {
      this.$refs.loginForm.validate((success) => {
        if (success) {
          this.$http.request({
            method: 'post',
            url: '/api/cgAdmins/login',
            data: JSON.stringify({
              username: this.loginForm.username,
              password: md5(this.loginForm.password)
            })
          }).then((res) => {
            localStorage.setItem('username', this.loginForm.username)
            sessionStorage.setItem('admin', JSON.stringify(res.data.data))
            location.href = web
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style>
.login-container{padding-top:0.1px;background:#4489FE;height:calc(100vh - 60px);margin-left:-16px;margin-right:-16px;margin-top:-1px;}
.login-card{width:600px;margin:60px auto 0;padding:30px;border:1px solid #eee;border-radius:6px;box-sizing:border-box;box-shadow:0 5px 15px rgba(0,0,0,.5);background:#FFF;}
.login-card .el-button{width:100%;margin:30px auto 0;}
</style>
